export default __webpack_public_path__ + "static/media/suitcase-outlined.28e41d34.svg";